import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import { apiDecrypt, apiEncrypt } from '@/utils/encryption/aesEncrypt'
import { OpenApiEncrypt } from '@/utils/config/SysBaseConfig'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import router from '../router'
/**
 * 【指定 axios的 baseURL】
 * 如果手工指定 baseURL: '/jeecg-boot'
 * 则映射后端域名，通过 vue.config.js
 * @type {*|string}
 */
// let apiBaseUrl = 'http://localhost:8585/hqptApi' || '/jeecg-boot'
let apiBaseUrl = window._CONFIG['domianURL'] || '/jeecg-boot'


//console.log("apiBaseUrl= ",apiBaseUrl)
// 创建 axios 实例
const service = axios.create({
  // baseURL: '/',//系统监控下菜单使用此地址
  // baseURL: '/jeecg-boot',
  baseURL: apiBaseUrl, // api base_url
  timeout: 9000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    let data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    console.log('------异常响应------', token)
    console.log('------异常响应------', error.response.status)
    switch (error.response.status) {
      case 403:
        Vue.prototype.$notification.error({ message: '系统提示', description: '拒绝访问', duration: 4 })
        break
      case 500:
        console.log('------error.response------', error.response)
        // update-begin- --- author:liusq ------ date:20200910 ---- for:处理Blob情况----
        let type = error.response.request.responseType
        if (type === 'blob') {
          blobToJson(data)
          break
        }
        // update-end- --- author:liusq ------ date:20200910 ---- for:处理Blob情况----
        if (token && data.message.includes('Token失效')) {
          // update-begin- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
          if (/wxwork|dingtalk/i.test(navigator.userAgent)) {
            Vue.prototype.$Jmessage.loading('登录已过期，正在重新登陆', 0)
          } else {
            Vue.prototype.$Jmodal.error({
              title: '登录已过期',
              content: '很抱歉，登录已过期，请重新登录',
              okText: '重新登录',
              mask: false,
              onOk: () => {
                // store.dispatch('Logout').then(() => {
                //   Vue.ls.remove(ACCESS_TOKEN)
                //   window.location.reload()
                // })
              }
            })
          }
          // update-end- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
        }
        break
      case 404:
        Vue.prototype.$notification.error({ message: '系统提示', description: '很抱歉，资源未找到!', duration: 4 })
        break
      case 504:
        Vue.prototype.$notification.error({ message: '系统提示', description: '网络超时' })
        break
      case 401:
        Vue.prototype.$notification.error({ message: '系统提示', description: '未登录，请登录后执行该操作', duration: 4 })
        break;
      default:
        Vue.prototype.$notification.error({
          message: '系统提示', description: data.message, duration: 4
        })
        break
    }
    return Promise.resolve(error)
  } else if (error.message) {
    if (error.message.includes('timeout')) {
      Vue.prototype.$notification.error({ message: '系统提示', description: '网络超时' })
    } else {
      Vue.prototype.$notification.error({ message: '系统提示', description: error.message })
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {

  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['X-Access-Token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
  //update-begin-author:qjh date: 2024-08-12 14:26:35 for: 需要判断数据是否为加密过的数据，如果是string类型则需要进行解密操作
  let data = response.data
  if (OpenApiEncrypt) {
    if (typeof data === 'string') {
      data = apiDecrypt(data)
    }
  }
  return data
  //update-end-author:qjh date: 2024-08-12 14:26:35 for: 需要判断数据是否为加密过的数据，如果是string类型则需要进行解密操作
}, err)

const installer = {
  vm: {}, install(Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

/**
 * Blob解析
 * @param data
 */
function blobToJson(data) {
  let fileReader = new FileReader()
  let token = Vue.ls.get(ACCESS_TOKEN)
  fileReader.onload = function () {
    try {
      let jsonData = JSON.parse(this.result)  // 说明是普通对象数据，后台转换失败
      console.log('jsonData', jsonData)
      if (jsonData.status === 500) {
        console.log('token----------》', token)
        if (token && jsonData.message.includes('Token失效')) {
          Modal.error({
            title: '登录已过期', content: '很抱歉，登录已过期，请重新登录', okText: '重新登录', mask: false, onOk: () => {
              // store.dispatch('Logout').then(() => {
              //   Vue.ls.remove(ACCESS_TOKEN)
              //   window.location.reload()
              // })
            }
          })
        }
      }
    } catch (err) {
      // 解析成对象失败，说明是正常的文件流
      console.log('blob解析fileReader返回err', err)
    }
  }
  fileReader.readAsText(data)
}

export {
  installer as VueAxios, service as axios
}